<!-- 销售一步出库数据操作 -->
<template>
   <div>
      <div v-if="isLoaded">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">

                                 <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                               :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <!-- 日期 -->
                                    <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                                             :isShowLong="false" :isdisabled="formOneValue.isChange == 0
                                          || dataActionBox.actionType == 2
                                          || (sendDataInfo.allotDetailAdds.length > 0 && formOneValue.isUpdate == 0)">
                                    </df-date>
                                    <!-- 检索方案 -->
                                    <el-tooltip v-else-if="formOneValue.entityField == 'coName'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                 :disabled="sendDataInfo.allotDetailAdds.length > 0 ? true : false">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append" icon="el-icon-search"
                                                     :disabled="sendDataInfo.allotDetailAdds.length > 0 ? true : false">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <!-- 检索方案 -->
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" :disabled="sendDataInfo[formOneValue.entityField] ? (formOneValue.isChange == 0
                                             || (sendDataInfo.allotDetailAdds.length > 0 && formOneValue.isUpdate == 0)
                                             || dataActionBox.actionType == 2) : false">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append" icon="el-icon-search"
                                                     :disabled="sendDataInfo[formOneValue.entityField] ? (formOneValue.isChange == 0
                                                || (sendDataInfo.allotDetailAdds.length > 0 && formOneValue.isUpdate == 0)
                                                || dataActionBox.actionType == 2) : false">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange" :disabled="formOneValue.isChange == 0
                                          || (sendDataInfo.allotDetailAdds.length > 0 && formOneValue.isUpdate == 0)
                                          || dataActionBox.actionType == 2" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="String(item.value)">
                                       </el-option>
                                    </el-select>
                                    <!-- 账期 -->
                                    <el-input @keyup.enter.native="nextFocus(formOneKey)" type="number" v-else-if="formOneValue.entityField == 'credit'"
                                              :disabled="formOneValue.isChange == 0 || (sendDataInfo.allotDetailAdds.length > 0 && formOneValue.isUpdate == 0)" v-model="sendDataInfo[formOneValue.entityField]"
                                              :maxlength="$store.state.inputLength"></el-input>
                                    <!-- string类型 -->
                                    <el-input @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)" v-else :disabled="formOneValue.isChange == 0
                                          || (sendDataInfo.allotDetailAdds.length > 0 && formOneValue.isUpdate == 0)
                                          || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{
                                             $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                          }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.entityField == 'isWms'">{{ sendDataInfo.isWms
                                       == 1 ? '是' : '否' }}</span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细操作 -->
                           <el-form :inline="true" size="mini">
                              <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                 <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                                    新增明细</el-button>
                                 <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="sendDataInfo.allotDetailAdds.length < 1">删除明细</el-button>
                                 <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                    (Alt+F1：新增明细</el-link>
                                 <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                    Alt+F2：删除明细)</el-link>
                              </div>
                           </el-form>
                           <!-- 明细信息 -->
                           <el-table class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.allotDetailAdds" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                     @selection-change="handleSelectionChange" border size="mini" :height="mxHeight">
                              <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                 <template slot-scope="scope">
                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                       <i class="el-icon-thumb"></i>
                                    </el-radio>
                                 </template>
                              </el-table-column>
                              <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in mxForm.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1"
                                               :min-width="formOneValue.fieldWeight" show-overflow-tooltip>
                                 <template slot-scope="scope">
                                    <!-- 显示通用名称 -->
                                    <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName'
                                       && dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable
                                              @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField)"
                                              v-model="sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]">
                                       <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField)" slot="append"
                                                  icon="el-icon-search"></el-button>
                                    </el-input>
                                    <span v-else-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo.allotDetailAdds[scope.$index][formOneValue.riftField])">
                                          {{
                                             sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]
                                          }}</a>
                                    </span>
                                    <!-- 生产日期 -->
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]">
                                          {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                       </span>
                                    </span>

                                    <input class="newInput" @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'woadPnumber'
                                          && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @input="calculatePrice(5, scope.$index)" type="number"
                                           v-model="sendDataInfo.allotDetailAdds[scope.$index].woadPnumber" />

                                    <!-- 含税价格 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'psprice'
                                          && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.allotDetailAdds[scope.$index].woadPnumber <= 0" @change="doCheckPrice(2, scope.$index)"
                                              @input="calculatePrice(2, scope.$index)" v-model="sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <!-- 单价 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'price'
                                          && dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number" :disabled="sendDataInfo.allotDetailAdds[scope.$index].woadPnumber <= 0"
                                              @input="calculatePrice(1, scope.$index)" v-model="sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <!-- 总金额 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'money'
                                          && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.allotDetailAdds[scope.$index].woadPnumber <= 0" @input="calculatePrice(3, scope.$index)"
                                              v-model="sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]">
                                    </el-input>

                                    <!-- 含税金额 -->
                                    <el-input v-else-if="formOneValue.entityField == 'psmoney'
                                       && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                              type="number" :disabled="sendDataInfo.allotDetailAdds[scope.$index].woadPnumber <= 0" @input="calculatePrice(4, scope.$index)"
                                              v-model="sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <!-- 备注 -->
                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'woadRemark'
                                          && dataActionBox.actionType != 2 && formOneValue.isChange == 1" v-model.trim="sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]">
                                    </el-input>
                                    <el-select v-else-if="formOneValue.entityField == 'isTicket'" v-model="sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                       <el-option label="是" :value="1"></el-option>
                                       <el-option label="否" :value="0"></el-option>
                                    </el-select>
                                    <span v-else>
                                       {{ sendDataInfo.allotDetailAdds[scope.$index][formOneValue.entityField]
                                       }}
                                    </span>
                                 </template>
                              </el-table-column>
                           </el-table>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <v-foot :actionType="dataActionBox.actionType" :btnFlag="true" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                    @showPrintPlan="showPrintPlan"></v-foot>
         </div>
         <el-dialog title="缺货登记" :visible.sync="stockRegisterBox" width="500px" center top="2rem" :modal-append-to-body='true' :append-to-body="true">
            <el-form label-position="top" label-width="200px" size="mini">
               <el-form-item label="客户">
                  <el-input v-model="stockRegisterData.cmName" disabled></el-input>
               </el-form-item>
               <el-form-item label="商品">
                  <el-input v-model="stockRegisterData.bgmName" disabled></el-input>
               </el-form-item>
               <el-form-item label="缺货数量">
                  <el-input v-model="stockRegisterData.wolrRegnumber"></el-input>
               </el-form-item>
               <el-form-item label="备注说明">
                  <el-input v-model="stockRegisterData.wolrRemark"></el-input>
               </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
               <el-button @click="stockRegisterBox = false">取 消</el-button>
               <el-button type="primary" @click="addShortageRegistration">确 定</el-button>
            </span>
         </el-dialog>
         <el-dialog title="特价申请" :visible.sync="priceApplicationBox" width="60%" center top="2rem" :modal-append-to-body='true' :append-to-body="true">
            <el-form label-position="right" label-width="160px" size="mini">
               <el-form-item label="销售单位">
                  <el-input v-model="priceApplicationData.cmName" disabled></el-input>
               </el-form-item>
               <el-form-item label="商品">
                  <el-input v-model="priceApplicationData.bgmName" disabled></el-input>
               </el-form-item>
               <el-form-item label="批号">
                  <el-input v-model.trim="priceApplicationData.batchno" disabled></el-input>
               </el-form-item>
               <el-form-item label="货主">
                  <el-input v-model.trim="priceApplicationData.coName" disabled></el-input>
               </el-form-item>
               <el-form-item label="生产日期">
                  <el-date-picker v-model="priceApplicationData.prodate" disabled type="date" placeholder="生产日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                  </el-date-picker>
               </el-form-item>
               <el-form-item label="有效期">
                  <el-date-picker v-model="priceApplicationData.expidate" disabled type="date" placeholder="有效期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                  </el-date-picker>
               </el-form-item>
               <el-form-item label="申请售价">
                  <el-input type="number" v-model="priceApplicationData.wosaAppprice"></el-input>
               </el-form-item>
               <el-form-item label="申请原因">
                  <el-input v-model.trim="priceApplicationData.wosaAppreason"></el-input>
               </el-form-item>
               <el-form-item label="申请截止日期">
                  <el-date-picker v-model="priceApplicationData.wosaEnddate" type="date" placeholder="有效期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                  </el-date-picker>
               </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
               <el-button @click="priceApplicationBox = false">取 消</el-button>
               <el-button type="primary" @click="addSpecialPriceApply">确 定</el-button>
            </span>
         </el-dialog>
      </div>
      <printPlan ref="printPlan"></printPlan>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <SearchSchemeOther ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <operSelect ref="operSelect" @drawerCancel="drawerCancel" @conAdd="conAdd"></operSelect>
      <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
         <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
      </el-dialog>
      <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
         <el-table :data="dialogList" border style="width: 100%">
            <el-table-column prop="level" label="类型" width="50">
               <template slot-scope="{row}">
                  <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                     {{ row.level == 0 ? "拦截" : '预警' }}
                  </span>
               </template>
            </el-table-column>
            <el-table-column prop="data" label="内容" min-width="180">
            </el-table-column>
            <el-table-column prop="validity" label="有效期" min-width="100">
               <template slot-scope="{row}">
                  {{ $common.getLocalTime(row.validity) }}
               </template>
            </el-table-column>
         </el-table>
         <span slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
         </span>
      </el-dialog>
      <div v-show="false">{{ some }}</div>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "allotListAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme,
   },
   data() {
      //这里存放数据
      return {
         showDialog: false,
         dialogList: [],
         focusIndex: '',
         dictionariesDatas: [], //配送方式
         detailRules: false, //规则
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            cmId: "", //销售单位
            opmId: "", //业务员
            opmName: "",
            cmName: "",
            salesId: "", //对方业务员
            salesName: "",
            stName: '',
            stId: '',
            caiId: "", //地址
            caiAddress: "", //地址
            coId: "",
            coName: "",
            credit: "",
            stId: '',
            dismode: "",
            payMethod: "",
            billType: '',
            wosiReserves1: "",
            wosiReserves2: "",
            wosiReserves3: "",
            wosiReserves4: "",
            wosiReserves5: "",
            wosiReserves6: "",
            settleMethod: "",
            allotDetailAdds: [],
            depId: "",
            depName: "",
            isWms: '',
            woamRemark: "",
            woamReserves1: "",
            woamReserves2: "",
            woamReserves3: "",
            woamReserves4: "",
            woamReserves5: "",
            woamReserves6: "",
            woamSalecus: "",
            woamSalecusid: 0,
            allotDate: "",
            woamSalesman: "",
            woamSalecusName: "",
            woamOpposalesman: "",
            totalCount: 0,
            totalMoney: 0,
            totalNumber: 0,
            recName: '',
            recId: '',
            loId: "",    //	物流公司ID
            companyName: "",    //	物流公司
            worcmChecker: "",
            worcmCheckerName: "",
            orderId: ''
         },
         inputel: '', //所有input对象
         detaislDataInfo: {
            //初始单条明细
            bgmId: "", //商品
            bgmName: "",
            batchno: "", //批号
            bgsId: "", //库存id
            costPrice: 0, //成本价
            costMoney: 0, //含税成本金额
            costAmount: 0, //成本金额-+
            expidate: "", //有效期
            coId: '',
            coName: '',
            stId: '',
            stName: '',
            gross: 0, //毛利
            lotno: "", //批次
            num: 0, //当前库存数量
            outRate: 0, //销项税率
            prodate: "", //生产
            sterBatchno: "", //灭菌批号
            woadPnumber: 0, //销售数量
            woadRemark: "", //备注
            money: 0, //金额
            price: 0, //单价
            psmoney: 0, //含税金额
            psprice: 0, //含税价格
            woadReserves1: "", //预留字段
            woadReserves2: "",
            woadReserves3: "",
            woadReserves4: "",
            woadReserves5: "",
            woadReserves6: "",
            bgiType: "",
            woadWcost: 0,
            packingSpec: '',
            placeorigin: '',
            isTicket: 0,
         },
         showTabs: "",
         formDataList: [],
         dictionariesData: {},
         // userOneList:[],
         selectedDetailsIndex: 0,
         // 缺货登记
         stockRegisterBox: false,
         stockRegisterData: {
            bgmId: "",
            bgmName: "",
            cmId: "",
            cmName: "",
            wolrRegnumber: "",
            wolrRemark: "",
         },
         storageRoomList: [], //库房
         // 特价申请
         priceApplicationBox: false,
         priceApplicationData: {
            bgmId: "",  //商品
            bgmName: "",
            coId: "",  //货主
            coName: "",
            wosaSalecus: "",
            cmId: "",
            cmName: "",
            wosaAppprice: "", // 申请售价
            wosaAppreason: "", // 申请原因
            batchno: "", // 批号
            expidate: "", // 	有效期
            wosaEnddate: "", // 申请截止日期
            wosaMinprice: "", // 最低售价
            prodate: "", // 	生产日期
            acType: 0, // 0自动提交，1手动提交
         },
         editDateilsIndex: "",
         giftsList: [],
         seTitle: "", //检索
         DialogVisible: false,
         seId: 0,
         cmId: "",
         ormId: "",
         coId: 0,
         seType: "",
         seIndex: 0,
         levleId: 0,
         seWidth: "0",
         mxHeight: 0,
         isLoaded: false,
         pageType: 'one',
         parentSearchData: {
            orderType: 0,   //	订单类型0.药品1.器械
         },
         selectedRow: [], // 当前已选择行
         mainFormList: [], //过滤的主表单
         tabForm: [], // tab循环的主表单
         mxForm: [],
         footForm: [],
         sField: '', // 赋值字段
         fField: '', //焦点字段
         nosField: '', // 不可赋值字段
         DialogExtract: false,   //提取
         exId: "",
         exTitle: "",
         exWidth: "",
         ppId: "orderId",
         ticket: 0,
         nextSearch: false,
         some: 0,

      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.allotDetailAdds": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalCount = 0; //总条目数
            this.sendDataInfo.totalMoney = 0; // 总金额
            this.sendDataInfo.totalNumber = 0; // 总数量
            newValue.forEach((item, keys) => {
               console.log(item.psprice)
               for (let key in item) {
                  if (item[key] == null || item[key] == 'null') {
                     this.sendDataInfo.allotDetailAdds[keys][key] = ''
                  }
               }
               let a = item.woadPnumber;
               if (item.woadPnumber == "") {
                  item.woadPnumber = 0;
               } else if (a && a.length > 1 && a.substring(0, 1) == "0" && a.substring(1, 2) != ".") {
                  item.woadPnumber = a.substring(1, a.length);
               }
               let b = item.psprice;
               if (item.psprice == "") {
                  item.psprice = 0;
               } else if (b.length > 1 && b.substring(0, 1) == "0" && b.substring(1, 2) != ".") {
                  item.psprice = b.substring(1, b.length);
               }

               // 计算销售单价
               var thisPrice = this.$common.getDecimalInfo(
                  2,
                  NP.minus(
                     item.psprice,
                     NP.divide(NP.times(item.psprice, item.outRate), 100)
                  )
               );
               item.price = this.$common.getDecimalInfo(2, parseFloat(item.price))
               // 计算毛利
               // this.sendDataInfo.allotDetailAdds[keys].gross = NP.times(
               // 	NP.minus(thisPrice, item.costPrice),
               // 	item.woadPnumber
               // );

               this.sendDataInfo.totalMoney = NP.plus(
                  parseFloat(this.sendDataInfo.totalMoney),
                  parseFloat(item.psmoney)
               );
               this.sendDataInfo.totalNumber = NP.plus(
                  parseFloat(this.sendDataInfo.totalNumber),
                  parseFloat(item.woadPnumber)
               );
            });
            this.sendDataInfo.totalCount = newValue.length;
         },
         deep: true,
      },
      "sendDataInfo.cmName": {
         handler: function (newValue, oldValue) {
            // console.log("sendDataInfo.cmName", newValue, oldValue);
            if (newValue == '') {
               if (this.dataActionBox.actionType == 0 || (this.dataActionBox.actionType == 1 && this.sendDataInfo.allotDetailAdds.length == 0)) {
                  this.sendDataInfo.cmId = ''
                  this.sendDataInfo.salesId = ''
                  this.sendDataInfo.salesName = ''
                  this.sendDataInfo.caiId = ''
                  this.sendDataInfo.caiAddress = ''
                  this.sendDataInfo.recId = ''
                  this.sendDataInfo.recName = ''
               }
            } else if (newValue != oldValue && oldValue != '') {
               if (this.dataActionBox.actionType == 0 || this.dataActionBox.actionType == 1 && this.sendDataInfo.allotDetailAdds.length == 0) {
                  this.sendDataInfo.salesId = ''
                  this.sendDataInfo.salesName = ''
                  this.sendDataInfo.caiId = ''
                  this.sendDataInfo.caiAddress = ''
                  this.sendDataInfo.recId = ''
                  this.sendDataInfo.recName = ''
               }
            }
         },
         deep: true,
      },
      "sendDataInfo.dismode": {
         handler: function (newstr, oldValue) {
            this.$nextTick(() => {
               let newValue = newstr.replace(/\s*/g, "");
               this.sendDataInfo.dismode = newValue
               if (newValue != "物流" || newValue == '') {
                  this.sendDataInfo.companyName = ''
                  this.sendDataInfo.loId = ''
                  this.tabForm[0].jurconfigform.forEach((item) => {
                     if (item.entityField == "companyName") {
                        item.isShow = 0;
                     }
                  })

               } else {
                  this.tabForm[0].jurconfigform.forEach((item) => {
                     if (item.entityField == "companyName") {
                        item.isShow = 1;
                     }
                  });
               }

            })
            this.some++
            this.$forceUpdate();
         },
         deep: true,
      },
      // "sendDataInfo.orderId": {
      //     handler: function (newValue, oldValue) {
      //         if (newValue != '') {
      //     },
      //     deep: true,
      // },
   },
   //方法集合
   methods: {
      tabHeight(val) {
         this.mxHeight = val
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById('mainInfo')
         if (el) this.inputel = el.getElementsByTagName('input')
      },

      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index)
                  break
               }
            }
         }
      },

      // 输入框切换焦点
      nextFocus(index, fField) {
         if (index >= (this.inputel.length - 1)) {
            if (this.sendDataInfo.allotDetailAdds.length > 0) { }
            this.addDetail('sendDataInfo')
            return
         }
         if (fField == 'keydown') {
            this.addDetail('sendDataInfo')
            return
         }
         var aindex = index + 1
         if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
            this.nextFocus(aindex)
            return
         }
         this.$nextTick(() => {
            this.inputel[aindex].focus()
         })
      },

      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == '') {
               this.inputel[index].focus()
               break
            }
         }
      },
      closeChild() {
         this.parentSearchData.bgmId = ''
         this.parentSearchData.bgmName = ''
         addEventListener('keyup', this.keyUp)//创建监听键盘事件
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         console.log(field, index)
         this.seIndex = index
         if (field == 'keydown') {
            if (this.sendDataInfo.allotDetailAdds[index + 1] != undefined) {
               this.$refs['bgmName'][index + 1].focus()
               this.selectedDetailsIndex = index + 1
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex]);
               })
               return
            }
            this.addDetail('sendDataInfo')
            return
         }
         this.$refs[field][index].focus()
      },

      // 监听键盘事件
      keyUp(e) {
         if (e.key == 'F1') { // 右键新增明细
            e.preventDefault();
            this.addDetail('sendDataInfo')
            return
         } else if (e.key == 'F2') {
            e.preventDefault();
            this.deleteDetails()
         } else if (e.keyCode == 40) { // 下键
            // 表格为空，不执行下方 
            if (this.sendDataInfo.allotDetailAdds.length == 0) return
            let refsElTable = this.$refs.mxTableRef
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0
               } else if (this.selectedDetailsIndex == this.sendDataInfo.allotDetailAdds.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                  this.selectedDetailsIndex = 0
               } else { // 正常递增
                  this.selectedDetailsIndex++
               }
               if (!refsElTable) return
               let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex], false);
                  return;
               }
               // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex]); // 把现在当前行勾选
            })
         } else if (e.keyCode == 38) { // 上键
            if (this.sendDataInfo.allotDetailAdds.length == 0) return
            let refsElTable = this.$refs.mxTableRef
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0
               } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                  this.selectedDetailsIndex = this.sendDataInfo.allotDetailAdds.length - 1
               } else { // 正常递减
                  this.selectedDetailsIndex--
               }
               if (!refsElTable) return
               let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex], false);
                  return;
               }
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex]); // 把现在当前行勾选
            })
         } else if (e.key == 'F4') { // 保存
            this.sendDataAction('sendDataInfo')
         }

      },

      // 表格方法
      rowClassName({ row, rowIndex }) {
         let rowName = "",
            findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
         if (findRow) {
            rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
         }
         return rowName; //也可以再加上其他类名 如果有需求的话
      },

      // 选中行底色逻辑
      rowStyle({ row, rowIndex }) {
         Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false
         });
         let rowBackground = {}
         if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
         return rowBackground
      },

      // 明细表格点击选中
      clickEvent(row, column, event, params) {
         let refsElTable = this.$refs.mxTableRef; // 获取表格对象
         let findRow = {}
         this.selectedDetailsIndex = row.rowIndex
         findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
         //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
         if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(row, false);
            return;
         }
         refsElTable.clearSelection();
         refsElTable.toggleRowSelection(row);
      },

      // 保存已选择行
      handleSelectionChange(rows) {
         this.selectedRow = rows; // 保存已选择行
      },

      // 查看证照
      lookLicence() {
         if (this.sendDataInfo.cmId == '') {
            return this.$message({
               message: "请先选择销售单位",
               type: "warning",
            });
         }
         this.$parent.$parent.toDetail(this.sendDataInfo.cmId);
      },

      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2)
            this.$parent.$parent.toDetail(orderId);
         else this.$parent.$parent.$parent.toDetail(orderId);
      },

      //换行提示
      lineMessageBox(data) {
         let txtArr = data.message.split("<br/>");
         let newArr = [];
         const h = this.$createElement;
         for (const i in txtArr) {
            newArr.push(h("p", null, txtArr[i]));
         }
         this.$alert(h("div", null, newArr), "提示", {
            confirmButtonText: "确定",
            callback: (action) => { },
         });
      },
      //触发提取
      openExtSearch(id) {
         this.exId = id;
         this.exId = id;
         if (id == '9135943390138368') {
            this.ppId = 'woamId'
         } else if (id == '629899519725568') {
            this.ppId = "orderId"
         }
         this.DialogExtract = true;
      },
      //提取返回
      async getDataByChen(val) {
         console.log(val)
         if (val != "" || val != undefined) {
            for (let key in val) {
               if (key == "arrlistbychen") {
                  this.sendDataInfo.allotDetailAdds = val.arrlistbychen;
               } else {
                  if (key == 'opmName' && val[key] == null || key == 'depName' && val[key] == null || key == 'depId' && val[key] == null || key == 'opmId' && val[key] == null) {
                     this.sendDataInfo[key] = this.sendDataInfo[key]
                  } else if (val[key] == null || val[key] === "") {
                  } else {
                     this.sendDataInfo[key] = val[key];
                  }
                  if (this.sendDataInfo[key] == null || this.sendDataInfo[key] == 'null') this.sendDataInfo[key] = ''
                  this.sendDataInfo.totalMoney = 0
                  this.sendDataInfo.totalNumber = 0
                  this.sendDataInfo.totalCount = 0
               }
            }
            this.sendDataInfo.allotDetailAdds.forEach(item => {
               this.sendDataInfo.totalMoney += item.rrdPsmoney
               this.sendDataInfo.totalNumber += item.oldNum
            })
            this.sendDataInfo.totalCount = this.sendDataInfo.allotDetailAdds.length
            // let responseData = await this.$http.getOrderId({ ids: [val.psaiId] });
            // this.sendDataInfo.pisOrderauxinfVo = responseData.result;
            this.DialogExtract = false;
            this.$nextTick(() => {
               this.selectedDetailsIndex = 0
               let refsElTable = this.$refs.mxTableRef
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex]);
               this.nextFocus(0)
            })
         }
         this.parentSearchData.stId = this.sendDataInfo.stId
         this.parentSearchData.cmId = this.sendDataInfo.cmId
         this.parentSearchData.coId = this.sendDataInfo.coId
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
      openSearch(sId, index, type, sField, fField, nosField) {
         if (type == "salesName" || type == "caiAddress" || type == "recName") {
            if (this.sendDataInfo.cmId == "") {
               return this.$message({
                  message: "请先选择销售单位",
                  type: "warning",
               });
            }
         }
         this.DialogVisible = true;
         console.log(type);
         removeEventListener('keyup', this.keyUp)
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField
         this.fField = fField
         this.nosField = nosField
         // this.parentSearchData.bgmId = ''
         // this.parentSearchData.bgmName = ''
         if (type == 'bgmName') {
            this.parentSearchData.stId = this.sendDataInfo.stId
            this.parentSearchData.cmId = this.sendDataInfo.cmId
            this.parentSearchData.coId = this.sendDataInfo.coId
            if (!this.nextSearch) this.parentSearchData.bgmName = this.sendDataInfo.allotDetailAdds[this.seIndex].bgmName
            this.selectedDetailsIndex = this.seIndex
            let refsElTable = this.$refs.mxTableRef
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex]);
            return
         } else if (type == 'worcmCheckerName') {
            this.parentSearchData.opmSalesperson = ''
            this.parentSearchData.opmReviewer = 1
            this.parentSearchData.opmAcceptor = ''
            this.parentSearchData.opmKeeper = ''
         } else if (type == 'opmName') {
            this.parentSearchData.opmSalesperson = 1
         }
         if (type == 'cmName') {
            this.parentSearchData.ormId = JSON.parse(sessionStorage.getItem("loginInfo")).ormId
         }
         this.parentSearchData[type] = this.sendDataInfo[type]
      },

      // 不可赋值字段
      noSetField(val) {
         let arr = this.nosField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = ''
         })
      },

      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
         this.$nextTick(() => {
            this.nextFocus(this.seIndex, this.fField)
         })
      },

      // 清除赋值字段数据
      clearValue() {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = ''
         })
      },

      //检索带回数据,
      changeInputModel(val) {
         // debuggger
         if (val != "" || val != undefined) {
            console.log(val)
            this.DialogVisible = false;
            this.$nextTick(() => {
               addEventListener('keyup', this.keyUp)//创建监听键盘事件
               if (val.nextSearchId) {
                  this.nextSearch = true
                  this.parentSearchData.bgmId = val.bgmId
                  this.parentSearchData.bgmName = val.bgmName
                  this.openSearch(val.nextSearchId, this.seIndex, 'bgmName', '', 'woadPnumber')
                  return
               }
               this.nextSearch = false
               if (this.seType == 'cmName') {
                  this.sendDataInfo.inOrmId = val.ormId
                  this.$http.allotQueryCmInfo({
                     socialcode: val.socialcode
                  }).then(cmRes => {
                     if (cmRes && cmRes.status == 200) {
                        var cmObj = cmRes.result
                        //销售单位
                        this.$http.checkCustomerSale({
                           //校验单位
                           formId: this.formDataList[0].jciId, //表单ID
                           unitId: cmObj.cmId, //单位ID
                        }).then((res) => {
                           if (res && res.status == 200) {
                              this.dialogList = []
                              let flag = -1
                              if (res.result != null && res.result.length > 0) {
                                 res.result.forEach(item => { this.dialogList.push(item) })
                                 flag = this.dialogList.findIndex(item => item.level == 0)
                                 this.showDialog = true
                              }
                              if (flag == -1) {
                                 this.parentSearchData.cmId = cmObj.cmId;
                                 this.sendDataInfo.cmId = cmObj.cmId;
                                 this.sendDataInfo.cmName = cmObj.cmName;
                                 if (cmObj.salesName && cmObj.salesId && this.sField.indexOf('salesName') != -1 && this.sField.indexOf('salesId') != -1) {
                                    //对方业务员
                                    this.$http.checkSalesSale({
                                       //校验对方业务员
                                       formId: this.formDataList[0].jciId, //表单ID
                                       salesId: cmObj.salesId, //业务员ID
                                    }).then((res) => {
                                       if (res && res.status == 200) {
                                          let flag = -1
                                          if (res.result != null && res.result.length > 0) {
                                             res.result.forEach(item => { this.dialogList.push(item) })
                                             flag = this.dialogList.findIndex(item => item.level == 0)
                                             this.showDialog = true
                                          }
                                          if (flag == -1) {
                                             this.sendDataInfo.salesName = cmObj.salesName;
                                             this.sendDataInfo.salesId = cmObj.salesId;
                                             if (cmObj.recId && cmObj.recName && this.sField.indexOf('recName') != -1 && this.sField.indexOf('recId') != -1) {
                                                //收货员
                                                this.$http.checkRecSalesSale({
                                                   //校验收货员
                                                   formId: this.formDataList[0].jciId, //表单ID
                                                   salesId: cmObj.recId, //业务员ID
                                                }).then((res) => {
                                                   if (res && res.status == 200) {
                                                      let flag = -1
                                                      if (res.result != null && res.result.length > 0) {
                                                         res.result.forEach(item => { this.dialogList.push(item) })
                                                         flag = this.dialogList.findIndex(item => item.level == 0)
                                                         this.showDialog = true
                                                      }
                                                      if (flag == -1) {
                                                         this.paramValue(cmObj);
                                                      }
                                                   } else {
                                                      this.lineMessageBox(res);
                                                      return false;
                                                   }
                                                }).catch((rej) => {
                                                   this.lineMessageBox(rej);
                                                });
                                             } else {
                                                this.paramValue(cmObj)
                                             }
                                          } else {
                                             this.showDialog = true
                                          }
                                       } else {
                                          this.lineMessageBox(res);
                                          return false;
                                       }

                                    }).catch((rej) => {
                                       this.lineMessageBox(rej);
                                    });
                                 } else {
                                    this.paramValue(cmObj);
                                 }
                              } else {
                                 this.showDialog = true
                              }

                           } else {
                              this.lineMessageBox(res);
                              this.parentSearchData.cmId = ''
                              this.clearValue()
                              return false;
                           }
                        }).catch((rej) => {
                           this.lineMessageBox(rej);
                           this.parentSearchData.cmId = ''
                           this.clearValue()
                        });
                     } else {
                        this.lineMessageBox(cmRes);
                     }
                  }).catch(err => {
                     this.lineMessageBox(err);

                  })
               } else if (this.seType == 'salesName') {
                  //对方业务员
                  this.$http.checkSalesSale({
                     //校验对方业务员
                     formId: this.formDataList[0].jciId, //表单ID
                     salesId: val.salesId, //业务员ID
                  }).then((res) => {
                     // console.log(res);
                     if (res && res.status == 200) {
                        let flag = -1
                        if (res.result != null && res.result.length > 0) {
                           this.dialogList = res.result
                           flag = this.dialogList.findIndex(item => item.level == 0)
                           this.showDialog = true
                        }
                        if (flag == -1) {
                           this.paramValue(val);
                        }
                     } else {
                        this.lineMessageBox(res);
                        this.clearValue()
                        return false;
                     }
                  }).catch((rej) => {
                     this.lineMessageBox(rej);
                     this.clearValue()
                  });
               } else if (this.seType == 'coName') {
                  //货主
                  // this.ormId = val.ormId;
                  this.coId = val.coId;
                  this.sendDataInfo.ormId = this.ormId;
                  this.paramValue(val)
               } else if (this.seType == 'bgmName') {
                  if (val.length > 0) {
                     this.bgmSelect(val)
                     return
                  }
                  val.costAmount = 0
                  val.costMoney = 0
                  //商品明细
                  let bgiTypeArr = [], bgiRateArr = [];
                  this.sendDataInfo.allotDetailAdds.forEach((v) => {
                     if (v.bgiType && v.bgiType != null && v.bgiType != 'null') {
                        console.log(typeof v.bgiType);
                        bgiTypeArr.push(v.bgiType);
                     }
                     if (v.outRate && v.outRate != null && v.outRate != 'null') {
                        bgiRateArr.push(v.outRate);
                     }
                  });
                  if (val.bgiType && val.bgiType != null && val.bgiType != 'null') {
                     bgiTypeArr[this.seIndex] = val.bgiType;
                  }
                  bgiTypeArr.forEach((item, i) => {
                     if (item == null || item == 'null') bgiTypeArr.splice(i, 1)
                  })
                  bgiRateArr.push(val.outRate)
                  this.$http
                     .checkScopeSale({
                        //校验明细商品
                        formId: this.mxForm.jciId, //表单ID
                        unitId: this.sendDataInfo.cmId, //销售单位ID
                        bgmId: [val.bgmId], //商品id
                        bgsId: [val.bgsId],
                        ormId: this.ormId, //     组织ID
                        salesId: this.sendDataInfo.salesId, // 对方业务员ID
                        bgiTypes: bgiTypeArr, //	药品类型
                        taxs: bgiRateArr, //	税率
                        recId: this.sendDataInfo.recId,  //收货人
                     })
                     .then((res) => {
                        if (res && res.status == 200) {
                           let flag = -1
                           if (res.result != null && res.result.length > 0) {
                              this.dialogList = res.result
                              flag = this.dialogList.findIndex(item => item.level == 0)
                              this.showDialog = true
                           }
                           if (flag == -1) {
                              this.$set(this.sendDataInfo.allotDetailAdds, this.seIndex, JSON.parse(JSON.stringify(val)));
                              this.sendDataInfo.allotDetailAdds[this.seIndex].isTicket = Number(this.ticket)
                              this.$nextTick(() => {
                                 this.$set(this.sendDataInfo.allotDetailAdds[this.seIndex], "woadPnumber", 0);
                                 this.$set(this.sendDataInfo.allotDetailAdds[this.seIndex], "psmoney", 0);
                                 this.$set(this.sendDataInfo.allotDetailAdds[this.seIndex], "money", 0);
                                 this.$set(this.sendDataInfo.allotDetailAdds[this.seIndex], "psprice", 0);
                                 this.parentSearchData.bgmId = ''
                                 this.parentSearchData.bgmName = ''
                                 this.tableNextFocus(this.fField, this.seIndex)
                                 this.selectedDetailsIndex = this.seIndex
                                 let refsElTable = this.$refs.mxTableRef
                                 refsElTable.clearSelection();
                                 refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex]);
                              })
                           }
                           // this.sendDataInfo.allotDetailAdds[this.seIndex] = JSON.parse(JSON.stringify(val))
                        } else {
                           this.lineMessageBox(res);
                           this.$set(this.sendDataInfo.allotDetailAdds, this.seIndex, JSON.parse(JSON.stringify(this.detaislDataInfo)));
                           return false;
                        }
                        console.log('allotDetailAdds', this.sendDataInfo.allotDetailAdds)
                     }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.$set(this.sendDataInfo.allotDetailAdds, this.seIndex, JSON.parse(JSON.stringify(this.detaislDataInfo)));
                     });

               } else if (this.seType == 'recName') {
                  //收货员
                  this.$http.checkRecSalesSale({
                     //校验收货员
                     formId: this.formDataList[0].jciId, //表单ID
                     salesId: val.salesId, //业务员ID
                  }).then((res) => {
                     if (res && res.status == 200) {
                        let flag = -1
                        if (res.result != null && res.result.length > 0) {
                           this.dialogList = res.result
                           flag = this.dialogList.findIndex(item => item.level == 0)
                           this.showDialog = true
                        }
                        if (flag == -1) {
                           this.paramValue(val);
                        }
                     } else {
                        this.lineMessageBox(res);
                        this.clearValue()
                        return false;
                     }
                  }).catch((rej) => {
                     this.lineMessageBox(rej);
                     this.clearValue()
                  });
               } else {
                  this.paramValue(val)
               }
            })
         }
      },
      //多选商品数据处理
      bgmSelect(val) {
         //商品明细
         let bgiTypeArr = [],
            bgiRateArr = [],
            bgmIds = [], bgsIds = [];
         this.sendDataInfo.allotDetailAdds.forEach((v) => {
            if (
               v.bgiType &&
               v.bgiType != null &&
               v.bgiType != "null" &&
               v.bgmName != ""
            ) {
               bgiTypeArr.push(v.bgiType);
            }
            if (
               v.outRate &&
               v.outRate != null &&
               v.outRate != "null" &&
               v.bgmName != ""
            ) {
               bgiRateArr.push(v.outRate);
            }
         });
         val.forEach(item => {
            item.costAmount = 0;
            item.costMoney = 0;
            bgiTypeArr.push(item.bgiType)
            bgmIds.push(item.bgmId)
            bgsIds.push(item.bgsId)
         })
         bgiTypeArr.forEach((item, i) => {
            if (item == null || item == "null")
               bgiTypeArr.splice(i, 1);
         });
         this.$http
            .checkScopeSale({
               //校验明细商品
               formId: this.mxForm.jciId, //表单ID
               unitId: this.sendDataInfo.cmId, //销售单位ID
               bgmId: bgmIds, //商品id
               bgsId: bgsIds,
               ormId: this.ormId, //     组织ID
               salesId: this.sendDataInfo.salesId, // 对方业务员ID
               bgiTypes: bgiTypeArr, //	药品类型
               taxs: bgiRateArr, //	税率
               recId: this.sendDataInfo.recId, //收货人
            })
            .then((res) => {
               if (res && res.status == 200) {
                  let flag = -1
                  this.dialogList = res.result
                  if (this.dialogList != null && this.dialogList.length > 0) {
                     flag = this.dialogList.findIndex(item => item.level == 0)
                     this.showDialog = true
                  }
                  if (flag == -1) {
                     var mx = JSON.parse(JSON.stringify(val))
                     mx.forEach(item => {
                        this.$set(item, "isTicket", Number(this.ticket));
                        this.$set(item, "woadPnumber", 0);
                        this.$set(item, "psmoney", 0);
                        this.$set(item, "money", 0);
                     })
                     if (this.sendDataInfo.allotDetailAdds && this.sendDataInfo.allotDetailAdds.length > 0) {
                        this.sendDataInfo.allotDetailAdds.forEach((item, index) => {
                           if (item.bgmId == '' || item.bgmName == '') {
                              this.sendDataInfo.allotDetailAdds.splice(index, 1)
                           }
                        })
                        mx.forEach((item) => {
                           this.sendDataInfo.allotDetailAdds.push({})
                           for (const key in this.detaislDataInfo) {
                              this.$set(this.sendDataInfo.allotDetailAdds[this.sendDataInfo.allotDetailAdds.length - 1], key, item[key] != undefined && item[key] != null ? item[key] : '')
                           }
                           var setField = []
                           if (this.setField) {
                              setField = this.setField.split(",")
                              setField.forEach(item1 => {
                                 if (item1 == "psprice") {
                                    this.$set(this.sendDataInfo.allotDetailAdds[this.sendDataInfo.allotDetailAdds.length - 1],"psprice",item.psprice);
                                 } else {
                                    this.$set(this.sendDataInfo.allotDetailAdds[this.sendDataInfo.allotDetailAdds.length - 1],"psprice",0 );
                                 }
                              })
                           } else {
                              this.$set(this.sendDataInfo.allotDetailAdds[this.sendDataInfo.allotDetailAdds.length - 1],"psprice",0);
                           }
                        })
                     } else {
                        this.sendDataInfo.allotDetailAdds = []
                        mx.forEach((item, index) => {
                           this.sendDataInfo.allotDetailAdds.push({})
                           for (const key in this.detaislDataInfo) {
                              this.$set(this.sendDataInfo.allotDetailAdds[index], key, item[key] != undefined && item[key] != null ? item[key] : '')
                           }
                           var setField = []
                           if (this.setField) {
                              setField = this.setField.split(",")
                              setField.forEach(item1 => {
                                 if (item1 == "psprice") {
                                    this.$set(this.sendDataInfo.allotDetailAdds[index],"psprice",item.psprice);
                                 } else {
                                    this.$set(this.sendDataInfo.allotDetailAdds[index],"psprice",0);
                                 }
                              })
                           } else {
                              this.$set(this.sendDataInfo.allotDetailAdds[index],"psprice",0);
                           }
                        })
                     }

                  } else {
                     this.$set(this.sendDataInfo.allotDetailAdds,this.seIndex,JSON.parse(JSON.stringify(this.detaislDataInfo)));
                     return false;
                  }
               }
            })
            .catch((rej) => {
               this.lineMessageBox(rej);
               this.$set(this.sendDataInfo.allotDetailAdds,this.seIndex,JSON.parse(JSON.stringify(this.detaislDataInfo)));
            });

      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      // 打印方法
      showPrintPlan() {
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      //确认新增
      async sendDataAction(formName1) {
         let flag = false;
         this.$refs[formName1].validate((valid) => {
            if (valid) {
            } else {
               this.$message({
                  message: "请完善主表单必填信息",
                  type: "error",
               });
               flag = true;
               return false;
            }
         });
         if (flag) return false;
         if (this.sendDataInfo.allotDetailAdds.length < 1) {
            this.$message({
               message: "请添加明细",
               type: "error",
            });
            return false;
         } else {
            this.sendDataInfo.allotDetailAdds.forEach((item, index) => {
               if (item.bgmId == '') {
                  this.sendDataInfo.allotDetailAdds.splice(index, 1)
               }
            })
         }
         if (this.sendDataInfo.orderId == '') {
            for (let j = 0; j < this.sendDataInfo.allotDetailAdds.length; j++) {
               const itemvs = this.sendDataInfo.allotDetailAdds[j];
               if (
                  itemvs.woadPnumber <= 0 ||
                  itemvs.woadPnumber > itemvs.saleableNum
               ) {
                  this.$message({
                     message: "请填写商品、合理的销售数量",
                     type: "error",
                  });
                  this.$set(itemvs, "woadPnumber", 0);
                  return false;
               }
            }
         }
         for (let key in this.sendDataInfo) {
            if (key == "") delete this.sendDataInfo[key]
         }
         if (this.dataActionBox.actionType == 0) {
            if (this.pageType == 'one') {
               var responseData = await this.$http.allotadd(this.sendDataInfo);
            }
         } else {
            if (this.pageType == 'one') {
               var responseData = await this.$http.allotupdate(this.sendDataInfo);
            }
         }

         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$refs.operSelect.openBox(responseData.result)
         } else {
            let txtArr = responseData.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
               newArr.push(h("p", null, txtArr[i]));
            }
            this.$message({
               message: h("div", null, newArr),
               type: "error",
            });
         }
      },
      drawerCancel() {
         this.$emit("drawerCancel", true)
      },
      conAdd() {
         this.init()
         this.dataActionBox.actionType = 0
      },
      //新增明细
      addDetail(sendDataInfo) {
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               this.sendDataInfo.allotDetailAdds.push({})
               var index = this.sendDataInfo.allotDetailAdds.length - 1
               for (const key in this.detaislDataInfo) {
                  this.$set(this.sendDataInfo.allotDetailAdds[index], key, this.detaislDataInfo[key])
               }
               this.$nextTick(() => {
                  this.selectedDetailsIndex = Number(this.sendDataInfo.allotDetailAdds.length - 1)
                  this.tableNextFocus('bgmName', this.selectedDetailsIndex)
                  let refsElTable = this.$refs.mxTableRef
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex]);
               })
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "warning",
               });
            }
         });
      },
      // 打开特价申请
      openPriceApplicationBox(goodsIndex = "") {
         if (this.sendDataInfo.allotDetailAdds.length >= 1) {
            if (goodsIndex == "") {
               var dataInfo =
                  this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex];
            } else {
               var dataInfo = this.sendDataInfo.allotDetailAdds[goodsIndex];
            }
            this.priceApplicationData.bgmId = dataInfo.bgmId;
            this.priceApplicationData.bgmName = dataInfo.bgmName;
            this.priceApplicationData.coId = this.sendDataInfo.coId;
            this.priceApplicationData.coName = this.sendDataInfo.coName;
            this.priceApplicationData.wosaSalecus = this.sendDataInfo.woamSalecus;
            this.priceApplicationData.cmId = this.sendDataInfo.cmId;
            this.priceApplicationData.cmName = this.sendDataInfo.cmName;
            this.priceApplicationData.wosaAppprice = "";
            this.priceApplicationData.wosaAppreason = "";
            this.priceApplicationData.batchno = dataInfo.batchno;
            this.priceApplicationData.expidate = dataInfo.expidate;
            this.priceApplicationData.wosaEnddate = "";
            this.priceApplicationData.wosaMinprice = "";
            this.priceApplicationData.expidate = dataInfo.expidate;

            this.priceApplicationBox = true;
         } else {
            this.$message({
               message: "请先添加明细数据",
               type: "error",
            });
         }
      },

      // 新增特价申请
      async addSpecialPriceApply() {
         if (this.priceApplicationData.wosaAppprice == "") {
            this.$message({
               message: "请填写申请售价",
               type: "error",
            });
            return false;
         }

         if (this.priceApplicationData.wosaEnddate == "") {
            this.$message({
               message: "请选择截止日期",
               type: "error",
            });
            return false;
         }

         let responseData = await this.$http.addSpecialPriceApply(
            this.priceApplicationData
         );
         if (responseData.status == 200) {
            this.priceApplicationBox = false;
            this.$message({
               message: "操作成功",
               type: "success",
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 打开缺货登记
      openStockRegisterBox() {
         if (this.sendDataInfo.allotDetailAdds.length >= 1) {
            var dataInfo =
               this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex];
            console.log("缺货登记", dataInfo);
            this.stockRegisterData.bgmId = dataInfo.bgmId;
            this.stockRegisterData.bgmName = dataInfo.bgmName;
            this.stockRegisterData.cmId = this.sendDataInfo.cmId;
            this.stockRegisterData.cmName = this.sendDataInfo.cmName;
            this.stockRegisterBox = true;
         } else {
            this.$message({
               message: "请先添加明细数据",
               type: "error",
            });
         }
      },

      // 新增缺货登记
      async addShortageRegistration() {
         if (this.stockRegisterData.wolrRegnumber == "") {
            this.$message({
               message: "请先填写登记数量",
               type: "error",
            });
            return false;
         }

         let responseData = await this.$http.addShortageRegistration(
            this.stockRegisterData
         );
         if (responseData.status == 200) {
            this.stockRegisterBox = false;
            this.$message({
               message: "操作成功",
               type: "success",
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      // 检测最低价
      async getGoodsSockPrice(goodsIndex) {
         var dataInfo = this.sendDataInfo.allotDetailAdds[goodsIndex];
         if (!dataInfo.psprice) {
            return false;
         }

         var sendData = {
            bgmId: dataInfo.bgmId,
            batchno: dataInfo.batchno,
            wosaAppprice: dataInfo.psprice,
            expidate: dataInfo.expidate,
            prodate: dataInfo.prodate,
            wosaSalecus: this.sendDataInfo.woamSalecus,
         };

         let responseData = await this.$http.getGoodsSockPrice(sendData);
         if (responseData.status == 200) {
            console.log(responseData);
            // this.stockRegisterBox = false
            // this.$message({
            // 	message: '操作成功',
            // 	type: 'success'
            // });
         } else {
            this.openPriceApplicationBox(goodsIndex);
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      //含税价拦截
      doCheckPrice(cate, index) {
         var info = this.sendDataInfo.allotDetailAdds[index];
         // console.log('info',info);
         let pspriceObj = {
            coId: info.coId, //货主ID
            bgmId: info.bgmId, //商品ID
            psprice: info.psprice, //商品价格
            costPrice: info.costPrice, //成本价
            cmId: this.sendDataInfo.cmId,  //客户ID
         }
         this.$http.checkPrice(pspriceObj).then((res) => {
            console.log('psprice', res);
            if (res.status == 200) {
               this.calculatePrice(cate, index)
            } else {
               this.$refs['woadPnumber'][this.seIndex].focus()
               this.$message({
                  message: res.message,
                  type: "error",
               });
               this.sendDataInfo.allotDetailAdds[index].psprice = 0
            }
         })
      },
      // 计算价格
      calculatePrice(cate = 1, index) {
         var info = this.sendDataInfo.allotDetailAdds[index];
         if (this.sendDataInfo.orderId == '') {
            if (info.woadPnumber <= 0) {
               this.$message({
                  message: "请先填写合理的销售数量",
                  type: "error",
               });
               this.$set(info, "woadPnumber", 0);
               this.$set(info, "money", 0);
               this.$set(info, "psmoney", 0);
               this.$set(info, "gross", 0); //毛利
               this.$set(info, "costMoney", 0); //含税成本金额
               this.$set(info, "costAmount", 0); //成本金额
               return false;
            } else if (info.woadPnumber > info.saleableNum) {
               info.woadPnumber = info.saleableNum
               this.$message({
                  message: "销售数量不能大于可销数量",
                  type: "error",
               });
            }
         }
         switch (cate) {
            case 1: // 通过单价计算全部
               // 计算含税价格 单价+单价*税率/100
               var thisPrice = this.$common.getDecimalInfo(2, NP.plus(info.price, NP.divide(NP.times(info.price, info.outRate), 100)));
               this.sendDataInfo.allotDetailAdds[index].psprice = thisPrice;
               // 计算金额 单价*数量
               this.sendDataInfo.allotDetailAdds[index].money = this.$common.getDecimalInfo(3, NP.times(info.price, info.woadPnumber));
               // 计算含税金额 含税价格*数量
               this.sendDataInfo.allotDetailAdds[index].psmoney = this.$common.getDecimalInfo(3, NP.times(thisPrice, info.woadPnumber));
               //计算税额
               this.sendDataInfo.allotDetailAdds[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
               break;
            case 2: // 通过含税价格计算全部
               // 计算含税金额 含税价格*数量
               this.sendDataInfo.allotDetailAdds[index].psmoney = info.woadPnumber === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.woadPnumber));
               // 计算金额 含税金额/(税率/100+1)
               var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.allotDetailAdds[index].psmoney, NP.plus(NP.divide(info.outRate, 100), 1)))
               // var midmoney = NP.divide(this.sendDataInfo.allotDetailAdds[index].psmoney, NP.plus(NP.divide(info.outRate, 100), 1)).toFixed(10)
               this.sendDataInfo.allotDetailAdds[index].money = this.$common.getDecimalInfo(3, midmoney);
               // 计算单价 金额/数量
               this.sendDataInfo.allotDetailAdds[index].price = info.woadPnumber === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.woadPnumber));
               //计算税额
               this.sendDataInfo.allotDetailAdds[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.allotDetailAdds[index].psmoney, this.sendDataInfo.allotDetailAdds[index].money))
               break;
            case 3: // 通过金额计算全部
               // 计算单价  金额 / 数量
               var thisPrice = this.$common.getDecimalInfo(2, NP.divide(info.money, info.woadPnumber));
               this.sendDataInfo.allotDetailAdds[index].price = thisPrice;
               // 计算含税价格 单价+单价*税率/100
               var thisPriceTwo = this.$common.getDecimalInfo(3, NP.plus(thisPrice, NP.divide(NP.times(thisPrice, info.outRate), 100)));
               this.sendDataInfo.allotDetailAdds[index].psprice = thisPriceTwo;

               // 计算含税金额 含税价格*数量
               this.sendDataInfo.allotDetailAdds[index].psmoney = this.$common.getDecimalInfo(3, NP.times(thisPriceTwo, info.woadPnumber));
               //计算税额
               this.sendDataInfo.allotDetailAdds[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
               break;

            case 4: // 通过含税金额计算全部
               // 计算含税价格  含税金额 / 数量
               this.sendDataInfo.allotDetailAdds[index].psprice = info.woadPnumber === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.psmoney, info.woadPnumber));
               // 计算总金额 含税金额/(税率/100+1)
               var midmoney = this.$common.getDecimalInfo(3, NP.divide(info.psmoney, NP.plus(NP.divide(info.outRate, 100), 1)))
               // var midmoney = NP.divide(info.psmoney, NP.plus(NP.divide(info.outRate, 100), 1)).toFixed(10)
               this.sendDataInfo.allotDetailAdds[index].money = this.$common.getDecimalInfo(3, midmoney);
               // 计算单价 金额/数量
               this.sendDataInfo.allotDetailAdds[index].price = info.woadPnumber === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.woadPnumber));
               //计算税额
               this.sendDataInfo.allotDetailAdds[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, this.sendDataInfo.allotDetailAdds[index].money));
               break;
            default:
               //通过数量计算
               // 计算含税金额 含税价格*数量
               var midmoney = info.woadPnumber === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.woadPnumber));
               // var midmoney = info.woadPnumber === 0 ? 0 : NP.times(info.psprice, info.woadPnumber).toFixed(10);
               this.sendDataInfo.allotDetailAdds[index].psmoney = this.$common.getDecimalInfo(3, midmoney);
               // 计算总金额 含税金额/(税率/100+1)
               this.sendDataInfo.allotDetailAdds[index].money = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.allotDetailAdds[index].psmoney, NP.plus(NP.divide(info.outRate, 100), 1)));
               // 计算整件数量
               const wholeNum = Math.floor(NP.divide(info.woadPnumber, Number(info.packingSpec)))
               this.sendDataInfo.allotDetailAdds[index].wholeNum = this.$common.getDecimalInfo(10, wholeNum);
               const scatNum = NP.minus(info.woadPnumber, NP.times(this.sendDataInfo.allotDetailAdds[index].wholeNum, Number(info.packingSpec)))
               //计算零散数量
               this.sendDataInfo.allotDetailAdds[index].scatNum = this.$common.getDecimalInfo(10, scatNum);
               //计算税额
               this.sendDataInfo.allotDetailAdds[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.allotDetailAdds[index].psmoney, this.sendDataInfo.allotDetailAdds[index].money));
               // 含税成本金额 = 含税成本 * 数量
               this.sendDataInfo.allotDetailAdds[index].costMoney = this.$common.getDecimalInfo(3, NP.times(info.woadWcost, info.woadPnumber));
               // 成本金额 = 库存成本 * 数量
               this.sendDataInfo.allotDetailAdds[index].costAmount = this.$common.getDecimalInfo(3, NP.times(info.costPrice, info.woadPnumber));

               // 计算件数 采数/包装单位
               if (parseFloat(info.packingSpec) <= 0 || info.packingSpec == "") {
                  this.sendDataInfo.allotDetailAdds[index].pieceNum = 0;
               } else {
                  this.sendDataInfo.allotDetailAdds[index].pieceNum = this.$common.getDecimalInfo(1, NP.divide(info.woadPnumber, info.packingSpec));
               }
               break;
         }

         // 含税金额
         var moneyFour = this.sendDataInfo.allotDetailAdds[index].psmoney;
         // 含税成本金额
         var moneyFive = this.sendDataInfo.allotDetailAdds[index].costMoney;

         // 毛利 = 含税金额 - 成本含税金额
         this.sendDataInfo.allotDetailAdds[index].gross = this.$common.getDecimalInfo(3, NP.minus(moneyFour, moneyFive));

         // 不含税毛利 = 金额 - 成本金额
         this.sendDataInfo.allotDetailAdds[index].taxgross = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.allotDetailAdds[index].money, this.sendDataInfo.allotDetailAdds[index].costAmount));
         //毛利率
         this.sendDataInfo.allotDetailAdds[index].grossProfit = moneyFour != 0 ? this.$common.toFixed2(NP.divide(this.sendDataInfo.allotDetailAdds[index].gross, moneyFour), 2) : 0
         console.log(this.sendDataInfo.allotDetailAdds[index].grossProfit);
         //页脚
         this.sendDataInfo.totalMoney = moneyFour;
         this.sendDataInfo.totalNumber = info.woadPnumber;
         this.sendDataInfo.totalCount = this.sendDataInfo.allotDetailAdds.length;
         this.sendDataInfo.allotDetailAdds.splice(1, 0);

      },

      //取消
      initActionBox(formName1, formName2) {
         this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel");
               this.init();
               this.$refs[formName1].resetFields();
               this.$refs[formName2].resetFields();
            })
            .catch(() => { });
      },

      //初始化
      init() {
         for (let key in this.sendDataInfo) {
            if (key == "allotDetailAdds") {
               this.sendDataInfo[key] = []
            } else {
               this.sendDataInfo[key] = "";
            }
         }
         this.sendDataInfo.allotDate = this.$moment().valueOf();

         this.sendDataInfo.allotDetailAdds = [];
         this.sendDataInfo.totalCount = 0;
         this.sendDataInfo.totalMoney = 0;
         this.sendDataInfo.totalNumber = 0;
         this.sendDataInfo.orderType = 0;   //orderType	订单类型0.药品订单1.器械订单
         this.parentSearchData = { orderType: 0 };   //	订单类型0.药品1.器械
         this.filterMainField()
         this.checkIsBuyer()
      },

      // 选择业务员
      selectUserOne(data) {
         data.forEach((item) => {
            if (item.opmId == this.sendDataInfo.woamSalesman) {
               this.sendDataInfo.depId = item.depId; //   业务部门
               this.sendDataInfo.depName = item.depName; //   业务部门
            }
         });
      },

      //上级流入
      openBox() {
         this.pageType = this.actionData.type
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.init();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.initDefaultValue()
            this.checkIsBuyer()
         } else if (this.dataActionBox.actionType == 1) {
            this.cmId = oldData.cmId;
            this.ormId = oldData.ormId
               ? oldData.ormId
               : JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
            this.coId = oldData.coId;
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            this.sendDataInfo = oldData;
            for (let key in this.sendDataInfo) {
               if (this.sendDataInfo[key] == null) this.sendDataInfo[key] = ''
            }
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
            }
            this.sendDataInfo.allotDetailAdds = dataInfo.detailVoList;
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
               this.initFocus()
            }, 16.7)
         });
      },
      // 默认值
      initDefaultValue() {
         let arr = this.formDataList[0].jurconfigform
         arr.forEach(item => {
            if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
               this.sendDataInfo[item.entityField] = item.defaultValue
            }
         })
         this.sendDataInfo.allotDate = this.$moment().valueOf();
      },

      //删除明细
      deleteDetails() {
         this.sendDataInfo.allotDetailAdds.splice(this.selectedDetailsIndex, 1);
         this.$nextTick(() => {
            if (this.sendDataInfo.allotDetailAdds.length > 1) {
               this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
               this.tableNextFocus('bgmName', this.selectedDetailsIndex)
               let refsElTable = this.$refs.mxTableRef
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.allotDetailAdds[this.selectedDetailsIndex]);
            } else {
               this.selectedDetailsIndex = 0
            }
         })
      },

      // 判断是不是采购员
      checkIsBuyer() {
         if (this.dataActionBox.actionType != 0) return
         let info = JSON.parse(sessionStorage.getItem('userInfo'))
         if (info.opmSalesperson == 1) {
            this.sendDataInfo.depName = info.depName
            this.sendDataInfo.depId = info.depId
            this.sendDataInfo.opmName = info.opmName
            this.sendDataInfo.opmId = info.opmId
            console.log(this.tabForm, "测试1");
            this.tabForm[0].jurconfigform.forEach(item => {
               if (
                  item.entityField == 'opmName' ||
                  item.entityField == 'depName')
                  item.isChange = 0
            })
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item))
               this.mxForm.jurconfigform.forEach(item1 => {
                  if (item1.fieldType == 'number') {
                     this.$set(this.detaislDataInfo, item1.entityField, 0)
                  } else if (item1.fieldType == 'search' && item1.setField) {
                     var arr = item1.setField.split(',')
                     arr.forEach(item2 => {
                        this.$set(this.detaislDataInfo, item2, "")
                     })
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "")
                  }
               })
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
            }
         })
         var arr = [{ entityField: "allotDetailAdds" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, "allotDate", this.$moment().valueOf())
         this.$set(this.sendDataInfo, "orderType", 0)
         this.mxForm.jurconfigform.forEach(item => {
            if (item.entityField == 'isTicket') {
               this.ticket = item.defaultValue
            }
         })
      },

   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$dbCache.Record_Get(4).then((res) => {//选择明细后不允许更换单位
         //明细拦截
         let obj = res
         if (obj.isEnable == 1) this.detailRules = true;
      });
      this.$nextTick(() => {
         this.openBox();

         this.isLoaded = true;
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      document.onkeydown = function () {
         if (window.event.keyCode === 38 || window.event.keyCode === 40) {
            window.event.returnValue = false;
         }
      }
      // addEventListener('keydown', this.keyDown)
      addEventListener('keyup', this.keyUp)//创建监听键盘事件
   },
   beforeDestroy() {
      removeEventListener('keyup', this.keyUp)
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput()
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

/* .table_content_box{
     height: 500px !important;
     overflow-y: auto;
 } */
.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}
</style>
<style>
.el-table .rowStyle {
   background: #fff7ca !important;
}
</style>